/**
 * @member {string} id
 * @member {string} sign
 * @member {string} current
 * @member {string|null} next
 */
export class StepTwoRequestDTO {
  constructor ({ id, sign, current }) {
    let properties = {
      configurable: false,
      enumerable: true,
      writable: false
    }
    Object.defineProperty(this, 'id', Object.assign({ value: id }, properties));
    Object.defineProperty(this, 'sign', Object.assign({ value: sign }, properties));
    Object.defineProperty(this, 'current', Object.assign({ value: parseInt(current) }, properties));
    Object.freeze(this);
  }

  id;

  sign;

  current;

  next;
}
